import { defineNuxtPlugin } from '@nuxtjs/composition-api';

export default defineNuxtPlugin(({ redirect, $api }) => {
  $api.onError(error => {
    if (error.response?.status === 401) {
      redirect('/home');
    }
  });
});
